import DataRoomNdaTimeline from './DataRoomNdaTimeline.component';

export default DataRoomNdaTimeline;